import { render, staticRenderFns } from "./InstructionFilePreview.vue?vue&type=template&id=07e40918&scoped=true"
import script from "./InstructionFilePreview.vue?vue&type=script&lang=ts"
export * from "./InstructionFilePreview.vue?vue&type=script&lang=ts"
import style0 from "./InstructionFilePreview.vue?vue&type=style&index=0&id=07e40918&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e40918",
  null
  
)

export default component.exports